import { ArcadeWheelStyle } from "@lib/titan2-slingo/dist/game/view/abstract/display/ArcadeWheel";
import { FontShadow, FontStroke } from "@lib/titan2/dist/game/control/properties/FontProperties";
import { GameColours } from "./GameColours";
/**
 * Font styles for text rendered through a vector font.
 */
export const GameFontConstants = {
    PRELOADER: { colour: GameColours.WHITE },
    LOADER_LIGHT: { colour: GameColours.WHITE },
    LOADER_DARK: { colour: "#000000" },
    TICKET_NUMBER: {
        colour: "#0076b6",
        stroke: new FontStroke(GameColours.WHITE, 6),
        shadow: new FontShadow("#000000", 6, 90, 0.2, 3)
    },
    TICKET_NUMBER_HIGHLIGHT: {
        colour: "#f53434",
        stroke: new FontStroke(GameColours.WHITE, 6),
        shadow: new FontShadow("#000000", 6, 90, 0.2, 3)
    },
    REEL_SYMBOL: {
        colour: GameColours.WHITE,
        stroke: new FontStroke("#000000", 8),
        shadow: new FontShadow("#000000", 6, 90, 0.2, 3)
    },
    REEL_SYMBOL_HIGHLIGHT: {
        colour: "#f22323",
        stroke: new FontStroke("#000000", 8),
        shadow: new FontShadow("#000000", 6, 90, 0.2, 3)
    },
    GAME_BUTTON: {
        colour: "#f2fcff",
        stroke: new FontStroke(GameColours.PURPLE, 8),
    },
    SPIN_BUTTON: {
        colour: "#f2fcff",
        stroke: new FontStroke(GameColours.PURPLE, 8),
    },
    COLLECT_BUTTON: {
        colour: "#f2fcff",
        stroke: new FontStroke(GameColours.PURPLE, 12),
    },
    RESPONSIBLE_GAMING_OPTION_BUTTON_DESELECTED: {
        colour: "#f2fcff",
        stroke: new FontStroke(GameColours.PURPLE, 8),
    },
    RESPONSIBLE_GAMING_OPTION_BUTTON_SELECTED: {
        colour: "#63ff2aff",
        stroke: new FontStroke(GameColours.PURPLE, 8),
    },
    PAY_TABLE_BUTTON: {
        colour: "#f2fcff",
        stroke: new FontStroke(GameColours.PURPLE, 10),
    },
    TEST_BUTTON: { colour: "#000000" },
    GAME_MESSAGES: {
        colour: GameColours.WHITE,
        stroke: new FontStroke("#000000", 6),
        shadow: new FontShadow("#000000", 6, 90, 0.2, 3)
    },
    SCATTER_PANEL_TITLE_MAX: {
        colour: GameColours.WHITE,
        stroke: new FontStroke("#efd246", 1.5),
        shadow: new FontShadow("#efd246", 0, 0, 1, 14),
    },
    SCATTER_PANEL_TITLE_MID: {
        colour: GameColours.WHITE,
        stroke: new FontStroke("#3695d5", 1.5),
        shadow: new FontShadow("#3695d5", 0, 0, 1, 14),
    },
    SCATTER_PANEL_TITLE_MIN: {
        colour: GameColours.WHITE,
        stroke: new FontStroke("#c800ff", 1.5),
        shadow: new FontShadow("#c800ff", 0, 0, 1, 14),
    },
    SCATTER_PANEL_FIELD: {
        colour: GameColours.WHITE,
        stroke: new FontStroke(GameColours.PURPLE, 6),
    },
    SCATTER_PANEL_TITLE: {
        colour: ["#f3e68e", "#e9fcf7", "#e9fcf7"],
        stops: [0.15, 0.75],
        stroke: new FontStroke("#311063", 6),
    },
    TOTAL_WIN_TITLE: {
        colour: GameColours.WHITE,
        stroke: new FontStroke(GameColours.PURPLE, 10),
    },
    TOTAL_WIN_VALUE: {
        colour: GameColours.WHITE,
        stroke: new FontStroke(GameColours.PURPLE, 10),
    },
    SPINS_REMAINING: {
        colour: GameColours.WHITE,
        shadow: new FontShadow(GameColours.BLUE, 0, 0, 1, 14),
    },
    PURCHASE_SPINS_REMAINING: {
        colour: GameColours.WHITE,
        shadow: new FontShadow(GameColours.PINK, 0, 0, 1, 14)
    },
    ARCADE_WHEEL_COUNTER: {
        colour: GameColours.WHITE,
        stroke: ArcadeWheelStyle.FONT_STROKE_SMALL,
        shadow: ArcadeWheelStyle.FONT_SHADOW_SMALL
    },
    ARCADE_WHEEL_INSTRUCTIONS: {
        colour: GameColours.WHITE,
        stroke: ArcadeWheelStyle.FONT_STROKE_LARGE,
        shadow: ArcadeWheelStyle.FONT_SHADOW_LARGE
    },
    ARCADE_WHEEL_SPIN_PRICE: {
        colour: GameColours.WHITE,
        stroke: ArcadeWheelStyle.FONT_STROKE_SMALL,
        shadow: ArcadeWheelStyle.FONT_SHADOW_SMALL
    },
    ARCADE_WHEEL_TOOLTIP_INFO: { colour: GameColours.WHITE },
    ARCADE_WHEEL_TOOLTIP_LABEL: { colour: GameColours.WHITE },
    GAME_SUMMARY_TITLE: {
        colour: GameColours.WHITE,
        stroke: new FontStroke(GameColours.PURPLE, 14),
        shadow: new FontShadow(GameColours.PURPLE, 5, 90, 1, 14),
    },
    GAME_SUMMARY_CELL: {
        colour: "#e3b0fb"
    },
    GAME_SUMMARY_CELL_VALUE: {
        colour: GameColours.WHITE,
        stroke: new FontStroke(GameColours.PURPLE, 10),
    },
    GAME_SUMMARY_TOTAL_WIN_LABEL: {
        colour: GameColours.WHITE,
        stroke: new FontStroke(GameColours.PURPLE, 14),
    },
    GAME_SUMMARY_TOTAL_WIN_VALUE: {
        colour: GameColours.WHITE,
        stroke: new FontStroke(GameColours.PURPLE, 8),
    },
    FULL_HOUSE: {
        colour: ["#ff0600", "#ff7900", "#fff400", "#04ff00", "#00f4ff", "#0001ff", "#da00ff"],
        stroke: new FontStroke("#8fc7ec", 10),
    },
    DIALOG: {
        colour: GameColours.WHITE,
        stroke: new FontStroke(GameColours.PURPLE, 8)
    },
    DIALOG_BUTTON_BIG: {
        colour: GameColours.WHITE,
        stroke: new FontStroke(GameColours.PURPLE, 12)
    },
    DIALOG_TITLE: {
        colour: GameColours.WHITE,
        stroke: new FontStroke(GameColours.PURPLE, 12),
    },
    RESPONSIBLE_GAMING_TITLE: {
        colour: GameColours.WHITE,
        stroke: new FontStroke(GameColours.PURPLE, 6),
    },
    WIN_LINE_AMOUNT: {
        colour: GameColours.WHITE,
        stroke: new FontStroke(GameColours.PINK, 1.5),
        shadow: new FontShadow(GameColours.PINK, 0, 0, 1, 20)
    },
    WIN_LINE_MULTIPLIER: {
        colour: GameColours.WHITE,
        stroke: new FontStroke(GameColours.BLUE, 1.5),
        shadow: new FontShadow(GameColours.BLUE, 0, 0, 1, 20)
    },
    SCATTER_PICK_INSTRUCTIONS: {
        colour: [
            "#d5fdfd",
            "#b0feff",
        ],
        stops: [0, 1],
        shadow: new FontShadow("#00abc5", 0, 0, 1, 14),
    },
    SCATTER_PICK_RIBBON_LOW: {
        colour: GameColours.WHITE,
        shadow: new FontShadow("#d733ca", 0, 0, 1, 14),
        stroke: new FontStroke("#d733ca", 4),
    },
    SCATTER_PICK_RIBBON_MEDIUM: {
        colour: GameColours.WHITE,
        shadow: new FontShadow("#00abc5", 0, 0, 1, 14),
        stroke: new FontStroke("#00abc5", 4),
    },
    SCATTER_PICK_RIBBON_HIGH: {
        colour: GameColours.WHITE,
        shadow: new FontShadow("#e7644a", 0, 0, 1, 14),
        stroke: new FontStroke("#e7644a", 4),
    },
    SCATTER_PICK_LABEL_MINI: {
        colour: ["#8d3c00", "#ab5708", "#f4a957"],
        stroke: new FontStroke("#af771c", 10),
    },
    SCATTER_PICK_LABEL_MINOR: {
        colour: ["#4d78c5", "#7ca3fd", "#fffffd"],
        stops: [0.25, 0.55, 0.8],
        stroke: new FontStroke("#17317d", 10),
    },
    SCATTER_PICK_LABEL_MAJOR: {
        colour: ["#dd8800", "#ffbb1d", "#ffff71"],
        stroke: new FontStroke("#ecb63e", 10),
    },
    SCATTER_PICK_MULTIPLIER: {
        colour: ["#eeb643", "#fffcb3", "#ecfefe", "#fffcb3", "#cf9016"],
        stops: [0.3, 0.46, 0.5, 0.52],
        stroke: new FontStroke("#4f2d1e", 10),
    },
    WIN_ANIMATION_COUNTER: {
        colour: ["#eeb643", "#fffcb3", "#ecfefe", "#fffcb3", "#cf9016"],
        stops: [0.3, 0.46, 0.5, 0.52],
        stroke: new FontStroke("#4f2d1e", 10),
    },
    WIN_ANIMATION_TITLE_0: {
        colour: ["#6e56ff", "#367bff", "#369eff", "#a5e3ff"],
        stops: [0.45, 0.65, 0.7, 1],
        stroke: new FontStroke(GameColours.PURPLE, 10),
    },
    WIN_ANIMATION_TITLE_1: {
        colour: ["#bd3ef3", "#fc709e", "#fc8b7d", "#fdcc2f"],
        stops: [0.4, 0.65, 0.75, 0.9],
        stroke: new FontStroke(GameColours.PURPLE, 10),
    },
    WIN_ANIMATION_TITLE_2: {
        colour: ["#ff741b", "#ffcd01", "#ffe287"],
        stops: [0.35, 0.65, 0.85],
        stroke: new FontStroke(GameColours.PURPLE, 10),
    },
    WIN_ANIMATION_TITLE_3: {
        colour: ["#ef454e", "#ff7d5c", "#ffdf0b"],
        stops: [0.35, 0.55, 0.85],
        stroke: new FontStroke(GameColours.PURPLE, 10),
    },
    LOADER_PLAY_BUTTON: {
        colour: "#f2fcff",
        stroke: new FontStroke("#047135", 20),
    },
    LOADER_PINK_TEXT: {
        colour: GameColours.WHITE,
        stroke: new FontStroke(GameColours.PINK, 4),
        shadow: new FontShadow(GameColours.PINK, 0, 0, 1, 20)
    },
    LOADER_BLUE_TEXT: {
        colour: GameColours.WHITE,
        stroke: new FontStroke("#0000ff", 12),
        shadow: new FontShadow("#0000ff", 0, 0, 1, 50)
    },
    GENERIC_WHITE_PURPLE: {
        colour: GameColours.WHITE
    }
};
;
//# sourceMappingURL=GameFontConstants.js.map